module.exports = __webpack_public_path__ + "img/company6.686e81fd.png";